import React from 'react';
import {
  KnowtationMark,
  MuseHubMark,
  OurwareMark,
  ScoolingMark,
} from './FamilyMarks';
import {
  KNOWTATION_NAME,
  KNOWTATION_ROLE,
  KNOWTATION_SUMMARY,
  KNOWTATION_URL,
  MUSEHUB_NAME,
  MUSEHUB_ROLE,
  MUSEHUB_SUMMARY,
  MUSEHUB_URL,
  OURWARE_ENTRANCE,
  OURWARE_NAME,
  OURWARE_ROLE,
  OURWARE_SOCIALS,
  OURWARE_URL,
  SCOOLING_NAME,
  SCOOLING_ROLE,
  SCOOLING_SUMMARY,
  SCOOLING_URL,
} from '../lib/communityOs';

const CommunityOperatingSystem: React.FC = () => {
  return (
    <section
      id="community-os"
      className="bg-gray-900 text-white"
      style={{ paddingTop: '48px', paddingBottom: '64px', scrollMarginTop: '120px' }}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-8 px-4 sm:px-8 lg:px-12">
          <div className="text-center mb-8 max-w-4xl mx-auto space-y-4">
            <h2 id="community-os-title" className="font-bold text-gray-200 scroll-mt-32" style={{ fontSize: '2.75rem', color: '#60a5fa' }}>
              Community Operating Systems
            </h2>
            <p data-testid="ourware-entrance-mission" className="text-gray-300 text-sm sm:text-base leading-relaxed">
              {OURWARE_ENTRANCE}
            </p>
            <p className="text-blue-300 text-base sm:text-lg leading-relaxed">
              Technical team partners are pursuing and advancing human sovereignty and freedom alongside us.
            </p>
            <p className="text-gray-300 text-sm leading-relaxed">
              BornFree is much more than properties—it is a ground-up vision built on this family as our basis. Connect a{' '}
              <a href={MUSEHUB_URL} target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300 font-medium">{MUSEHUB_NAME}</a>
              -style version graph, a{' '}
              <a href={KNOWTATION_URL} target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300 font-medium">{KNOWTATION_NAME}</a>
              {' '}vault source of truth, and{' '}
              <a href={SCOOLING_URL} target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300 font-medium">{SCOOLING_NAME}</a>
              {' '}learning workspaces so community life can become interaction, memory, pattern discovery, and shared governance—without hiding the foundation from members.
            </p>
          </div>

          <div className="rounded-xl border border-gray-600 bg-gray-800/50 p-5 sm:p-6 lg:p-8 mx-auto max-w-6xl">
            <div
              data-testid="ourware-parent-card"
              className="rounded-lg border border-blue-700/60 bg-blue-950/30 p-5 sm:p-6 mb-6 space-y-3"
            >
              <div className="flex items-start gap-4">
                <OurwareMark />
                <div className="space-y-1">
                  <h3 className="font-bold text-gray-100 text-xl">{OURWARE_NAME}</h3>
                  <p className="text-[10px] sm:text-xs uppercase tracking-wide text-blue-300">{OURWARE_ROLE}</p>
                </div>
              </div>
              <p className="text-gray-300 text-sm leading-relaxed">
                {OURWARE_ENTRANCE}
              </p>
              <div className="flex flex-wrap items-center gap-3">
                {OURWARE_SOCIALS.map((social) => (
                  <a
                    key={social.id}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`ourware-social-${social.id}`}
                    className="text-blue-400 hover:text-blue-300 text-sm font-medium"
                  >
                    {social.label}
                  </a>
                ))}
              </div>
              <a
                href={OURWARE_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="ourware-outbound"
                className="inline-block text-blue-400 hover:text-blue-300 text-sm font-medium"
              >
                Visit {OURWARE_NAME} →
              </a>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-6">
              <div className="rounded-lg border border-gray-700 bg-gray-800/50 p-5 space-y-3">
                <ScoolingMark />
                <div>
                  <h4 className="font-bold text-gray-200">{SCOOLING_NAME}</h4>
                  <p className="text-[10px] sm:text-xs uppercase tracking-wide text-gray-500 mt-1">{SCOOLING_ROLE}</p>
                </div>
                <p className="text-gray-400 text-sm leading-relaxed">
                  {SCOOLING_SUMMARY}
                </p>
                <a href={SCOOLING_URL} target="_blank" rel="noopener noreferrer" data-testid="scooling-outbound" className="inline-block text-emerald-400 hover:text-emerald-300 text-sm font-medium">
                  Explore {SCOOLING_NAME} →
                </a>
              </div>

              <div className="rounded-lg border border-gray-700 bg-gray-800/50 p-5 space-y-3">
                <MuseHubMark />
                <div>
                  <h4 className="font-bold text-gray-200">{MUSEHUB_NAME}</h4>
                  <p className="text-[10px] sm:text-xs uppercase tracking-wide text-gray-500 mt-1">{MUSEHUB_ROLE}</p>
                </div>
                <p className="text-gray-400 text-sm leading-relaxed">
                  {MUSEHUB_SUMMARY}
                </p>
                <a href={MUSEHUB_URL} target="_blank" rel="noopener noreferrer" className="inline-block text-purple-400 hover:text-purple-300 text-sm font-medium">
                  Explore {MUSEHUB_NAME} →
                </a>
              </div>

              <div className="rounded-lg border border-gray-700 bg-gray-800/50 p-5 space-y-3">
                <KnowtationMark />
                <div>
                  <h4 className="font-bold text-gray-200">{KNOWTATION_NAME}</h4>
                  <p className="text-[10px] sm:text-xs uppercase tracking-wide text-gray-500 mt-1">{KNOWTATION_ROLE}</p>
                </div>
                <p className="text-gray-400 text-sm leading-relaxed">
                  {KNOWTATION_SUMMARY}
                </p>
                <a href={KNOWTATION_URL} target="_blank" rel="noopener noreferrer" className="inline-block text-blue-400 hover:text-blue-300 text-sm font-medium">
                  View {KNOWTATION_NAME} →
                </a>
              </div>
            </div>

            <details className="rounded-md border border-gray-700/80 bg-gray-800/30 px-4 py-3">
              <summary className="cursor-pointer text-[#60a5fa] font-semibold text-sm list-none [&::-webkit-details-marker]:hidden">
                Technical details
              </summary>
              <div className="mt-3 text-gray-400 text-sm leading-relaxed space-y-3">
                <p>
                  Community Operating Systems is a network of open-source projects sharing patterns: tiered retrieval, proposals before commit, typed contracts, and JSON-friendly automation. BornFree properties and Keys sit on top of this stack—not apart from it. {OURWARE_NAME} is the organization that supports that family.
                </p>
                <p>
                  <strong className="text-gray-300">{OURWARE_NAME}</strong> — Independent operating-system hub for human endeavors across life, work, and play.{' '}
                  <a href={OURWARE_URL} target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300">ourware.org</a>
                </p>
                <p>
                  <strong className="text-gray-300">Muse / {MUSEHUB_NAME}</strong> — Domain-agnostic version control for multidimensional state; {MUSEHUB_NAME} adds hosted collaboration, REST API, and vector search across repositories.{' '}
                  <a href={MUSEHUB_URL} target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300">musehub.ai</a>
                </p>
                <p>
                  <strong className="text-gray-300">{KNOWTATION_NAME}</strong> — Indexed Markdown vaults, semantic search, memory consolidation, MCP/CLI for agents, scoped team roles, and attestation-ready proposals so AI suggests but humans approve.{' '}
                  <a href={KNOWTATION_URL} target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300">knowtation.store</a>
                </p>
                <p>
                  <strong className="text-gray-300">{SCOOLING_NAME}</strong> — Lifelong learning workspaces that connect reviewed material to private custom models, local-or-cloud policy, and pattern discovery across a member&apos;s full knowledge graph.{' '}
                  <a href={SCOOLING_URL} target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300">{SCOOLING_NAME}</a>
                </p>
              </div>
            </details>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CommunityOperatingSystem;
